import { getFunctions, httpsCallable } from 'firebase/functions';
import app from '../firebase/firebase';

const functions = getFunctions(app);

// Initialize Firebase Functions
const saveChatMessage = httpsCallable(functions, 'saveChatMessage');
const getChatHistory = httpsCallable(functions, 'getChatHistory');
const sendFollowUpQuestion = httpsCallable(functions, 'sendFollowUpQuestion');

export const chatService = {
  /**
   * Save a chat message to Firestore
   * @param {string} pageName - The name of the page
   * @param {string} sectionTitle - The title of the section
   * @param {string} message - The message content
   * @param {boolean} isUserMessage - Whether this is a user message or AI response
   * @param {string} aiResponse - The AI response (if applicable)
   * @returns {Promise<Object>} - The saved message data
   */
  async saveMessage(pageName, sectionTitle, message, isUserMessage = false, aiResponse = null) {
    try {
      const result = await saveChatMessage({
        pageName,
        sectionTitle,
        message,
        isUserMessage,
        aiResponse,
      });
      
      return result.data;
    } catch (error) {
      console.error('Error saving chat message:', error);
      throw error;
    }
  },

  /**
   * Retrieve chat history for a specific page and section
   * @param {string} pageName - The name of the page
   * @param {string} sectionTitle - The title of the section
   * @returns {Promise<Object>} - The chat history data
   */
  async getHistory(pageName, sectionTitle) {
    try {
      const result = await getChatHistory({
        pageName,
        sectionTitle,
      });
      
      return result.data;
    } catch (error) {
      console.error('Error retrieving chat history:', error);
      throw error;
    }
  },

  /**
   * Send a follow-up question and get AI response
   * @param {string} pageName - The name of the page
   * @param {string} sectionTitle - The title of the section
   * @param {string} question - The user's follow-up question
   * @param {Array} chatHistory - Previous chat messages
   * @param {string} originalSectionContent - Original section content
   * @param {string} fullContent - Full page content
   * @returns {Promise<Object>} - The AI response data
   */
  async sendFollowUp(pageName, sectionTitle, question, chatHistory = [], originalSectionContent = '', fullContent = '') {
    try {
      const result = await sendFollowUpQuestion({
        pageName,
        sectionTitle,
        question,
        chatHistory,
        originalSectionContent,
        fullContent,
      });
      
      return result.data;
    } catch (error) {
      console.error('Error sending follow-up question:', error);
      throw error;
    }
  },
};

export default chatService; 